import axios from "axios";

import AuthResponse from "../models/auth/AuthResponse";
import apiService from "./ApiService";

class AuthService {
  async login(loginRequest) {
    const authResponse = (
      await axios.post("/api/api/auth/login", loginRequest, {
        withCredentials: true,
      })
    ).data;
    apiService.defaults.headers.Authorization = `Bearer ${authResponse.token}`;
    return authResponse;
  }

  getToken() {
    return localStorage.getItem("token");
  }

  async logout(): Promise<void> {
    const token = localStorage.getItem("token");

    await apiService.post(
      "/api/auth/logout",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    apiService.defaults.headers.Authorization = null;
  }

  async forget(data) {
    const record = await apiService.post("/api/users/forget_password", data);
    return record;
  }

  async verifyOTP(data) {
    const record = await apiService.post("/api/users/verify_otp", data);
    return record;
  }

  async findOtp(id: string) {
    return (await apiService.get(`/api/users/findOtp/${id}`)).data;
  }

  async resetPassword(data) {
    const record = await apiService.post("/api/users/resetPassword", data);
    return record;
  }

  async refresh(): Promise<AuthResponse> {
    const authResponse = (
      await axios.post<AuthResponse>(
        "/api/api/auth/refresh", // Adjust based on the backend prefix
        {},
        { withCredentials: true }
      )
    ).data;

    apiService.defaults.headers.Authorization = `Bearer ${authResponse.token}`;
    return authResponse;
  }
}

const authService = new AuthService();
export default authService;
